import { useNavigate } from "react-router-dom";
import {
  LeftOutlined,
} from "@ant-design/icons";
import { Button, Row, Col, Divider } from "antd";

const GameHeader = (props) => {
  const navigate = useNavigate();
  function handleGoBack() {
      navigate("/");
  }

  return (
    <>
      <Row className="mt-2">
        <Col
          className="col d-flex align-items-center"
          justify="space-evenly"
          align="middle"
        >
          <Button
            type="primary"
            shape="circle"
            icon={<LeftOutlined />}
            onClick={handleGoBack}
          />{" "}
          <span className="m-1  h4">{props.headerName}</span>
        </Col>
      </Row>
      <Divider className="mt-1" />
    </>
  );
};

export default GameHeader;
